import { Skeleton } from 'primereact/skeleton';
import classes from './conceptDetails.module.scss';

const ConceptDetailsSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonHeading}>
        <Skeleton height="5rem" width="20rem"></Skeleton>
        <Skeleton height="5rem" width="30rem"></Skeleton>
      </div>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="8rem"></Skeleton>
        {/* <Skeleton height="8rem" width="46vw"></Skeleton> */}
      </div>
    </div>
  );
};

export default ConceptDetailsSkeleton;
